import { loadTranslations } from '@angular/localize';
import { expressionTranslations, storedLanguage } from './app/core/i18n/language';

/**
 * English is loaded BEFORE the application modules are imported (docs/features/org-language.md §6):
 * `$localize` in component code runs at module-init time for label maps and status dictionaries,
 * so the translations must already be in place when `./app/bootstrap` executes. Ukrainian needs
 * nothing — the source text is what the templates carry.
 */
async function start(): Promise<void> {
  if (storedLanguage() === 'en') {
    try {
      const response = await fetch('assets/i18n/en.json', { cache: 'no-cache' });
      if (response.ok) {
        const bundle = (await response.json()) as {
          translations?: Record<string, string>;
          expressions?: Record<string, string>;
        };
        if (bundle.translations) {
          loadTranslations(bundle.translations);
        }
        $localize.locale = 'en';
        Object.assign(expressionTranslations, bundle.expressions ?? {});
      }
    } catch (err) {
      console.error('i18n: English bundle failed to load, falling back to Ukrainian', err);
    }
  }
  await import('./app/bootstrap');
}

start();
